/* ═══════════════════════════════════════════════════
   DWL HERO — eindeloze merkenrij (mobiel)

   ÉÉN LUS, GEEN START/STOP.
   Eerdere versies startten en stopten de animatie via een
   IntersectionObserver, matchMedia en losse vlaggen. Elk van die
   schakelaars kon in de verkeerde stand blijven staan, en dan stond de
   rij stil zonder zichtbare oorzaak — wat ook gebeurde. Nu draait er
   één requestAnimationFrame-lus die per frame zelf kijkt of er iets te
   doen is. Er is geen toestand meer die verkeerd kán staan.

   WANNEER BEWEEGT HIJ? Alleen als de rij daadwerkelijk zichtbaar is
   (offsetParent en breedte). De sectie-CSS verbergt .duckie-marquee
   boven 768px, dus dat volgt de CSS precies in plaats van een eigen
   drempel te dubbelen.

   ⚠ ZET GEEN `transform` OP .duckie-marquee-track IN CSS. Dit script
   schrijft daar een inline waarde, en een inline style verliest van
   !important. Een regel `transform: none !important` legt de hele rij
   stil terwijl de inline waarde er gewoon staat.

   ⚠ GEEN mouseenter/mouseleave om te pauzeren: op iOS vuurt mouseenter
   bij een tap en de bijbehorende mouseleave vaak niet.

   AANPAK: transform met modulo, geen scrollLeft. scrollLeft kan niet
   voorbij scrollWidth - clientWidth, dus daar liep de rij aan het einde
   leeg. Met modulo kan er per definitie geen gat vallen.

   SPEED op 0 maakt 'm stil; slepen blijft werken.
   ════════════════════════════════════════════════════ */
(function () {
  var SPEED = 0.3;
  var RESUME_AFTER = 2000;
  var DRAG_THRESHOLD = 6;

  var wrap = null, track = null;
  var pos = 0, half = 0, lastWidth = 0;
  var paused = false, resumeTimer = null;
  var dragging = false, dragged = false, startX = 0, startPos = 0;

  function find() {
    if (wrap && wrap.isConnected) return true;
    wrap = document.querySelector('.duckie-marquee');
    track = wrap ? wrap.querySelector('.duckie-marquee-track') : null;
    return !!(wrap && track);
  }

  function visible() {
    return !!wrap && wrap.offsetParent !== null && wrap.clientWidth > 0;
  }

  function measure() {
    if (!track) return;
    var w = track.scrollWidth;
    if (w !== lastWidth) { lastWidth = w; half = w / 2; }
  }

  function normalise() {
    if (half <= 0) return;
    while (pos <= -half) pos += half;
    while (pos > 0) pos -= half;
  }

  function draw() {
    if (track) track.style.transform = 'translate3d(' + pos + 'px,0,0)';
  }

  function pointX(e) {
    if (e.touches && e.touches.length) return e.touches[0].clientX;
    if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientX;
    return e.clientX;
  }

  function onDown(e) {
    if (!visible()) return;
    dragging = true;
    dragged = false;
    startX = pointX(e);
    startPos = pos;
    paused = true;
    clearTimeout(resumeTimer);
    /* Vangnet: mist er een 'up', dan loopt hij vanzelf weer aan. */
    resumeTimer = setTimeout(function () { paused = false; dragging = false; }, 8000);
  }

  function onMove(e) {
    if (!dragging) return;
    var dx = pointX(e) - startX;
    if (Math.abs(dx) > DRAG_THRESHOLD) dragged = true;
    pos = startPos + dx;
    normalise();
    draw();
  }

  function onUp() {
    if (!dragging) return;
    dragging = false;
    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function () { paused = false; }, RESUME_AFTER);
  }

  /* Na slepen mag de tegel eronder niet meegeklikt worden. */
  function onClickCapture(e) {
    if (dragged) {
      e.preventDefault();
      e.stopPropagation();
      dragged = false;
    }
  }

  function attach() {
    if (!find()) return;
    if (wrap.dataset.dwlDrag === '1') return;
    wrap.dataset.dwlDrag = '1';

    wrap.addEventListener('pointerdown', onDown, { passive: true });
    window.addEventListener('pointermove', onMove, { passive: true });
    window.addEventListener('pointerup', onUp, { passive: true });
    window.addEventListener('pointercancel', onUp, { passive: true });

    wrap.addEventListener('touchstart', onDown, { passive: true });
    wrap.addEventListener('touchmove', onMove, { passive: true });
    wrap.addEventListener('touchend', onUp, { passive: true });
    wrap.addEventListener('touchcancel', onUp, { passive: true });

    wrap.addEventListener('click', onClickCapture, true);
  }

  function loop() {
    if (find()) {
      attach();
      if (visible()) {
        measure();
        if (!paused && !dragging && SPEED > 0 && half > 0) {
          pos -= SPEED;
          normalise();
          draw();
        }
      }
    }
    window.requestAnimationFrame(loop);
  }

  function boot() {
    attach();
    document.addEventListener('shopify:section:load', function () {
      wrap = null; track = null; lastWidth = 0; pos = 0;
    });
    window.requestAnimationFrame(loop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
